import styled from 'styled-components';
export const ScreenReaderOnly = styled.div `
  position: absolute;
  left: -99999px;
  height: 1px;
  width: 1px;
  overflow: hidden;
`;
